module.exports = __webpack_public_path__ + "static/scale-model-of-trapped-escape-game-nashville-in-nashville-tennessee-0870c9961fd76fda5ed860d3c993b901.png";